module.exports = __webpack_public_path__ + "static/media/contentHome2.264ab99b.png";